import { useCallback, useLayoutEffect, useState } from 'react';

import waitScriptReady from 'utils/wait-for-script-ready';

export default function useZeWidget() {
    const [visible, setVisible] = useState(false);

    const close = useCallback(
        () =>
            waitScriptReady('ze-snippet').then(() => {
                setVisible(false);
                window.zE?.('webWidget', 'hide');
            }),
        []
    );

    const open = useCallback(
        () =>
            waitScriptReady('ze-snippet').then(() => {
                setVisible(true);
                window.zE?.('webWidget', 'show');
                window.zE?.('webWidget', 'open');
            }),
        []
    );

    useLayoutEffect(() => {
        waitScriptReady('ze-snippet').then(() => {
            window.zE?.('webWidget', 'hide');
            window.zE?.('webWidget', 'setLocale', 'en');
            window.zE?.('webWidget:on', 'close', close);
        });
    }, [close]);

    return [visible, open, close] as const;
}
